import React from 'react';

const TopArtists = ({ artists }) => {
  if (!artists) return null;

  return (
    <div className="card">
      <div className="card-heading">
        <h1>artists</h1>
        <span className="num">N° 06</span>
      </div>
      <div className="card-content">
        <ol>
          {artists.slice(0, 25).map(artist => (
            <li key={artist.name}>
              <span className="track-name">{artist.name}</span>
              <span className="plays-count">{artist.playcount}</span>
            </li>
          ))}
        </ol>
      </div>
    </div>
  );
};

export default TopArtists;
